/**
 * Created by spepa on 24.12.2024
 */
var MSPwaSocial = function () {
    Social.call(this, connector.MSPWA);
};

MSPwaSocial.prototype = Object.create(Social.prototype);
MSPwaSocial.prototype.constructor = MSPwaSocial;

MSPwaSocial.prototype.getAccessToken = function () {
    return "MSPWA";
};
